import { useEffect } from "react";
import config from "../../../config";
import * as Stomp from "stompjs";
import { useSelector, useDispatch } from "react-redux";

var stompClient;

const SocketCLient = () => {
    const dispatch = useDispatch();
    const { isAuthenticated, token, fileStatus } = useSelector((state) => ({
        isAuthenticated: state.authenticationReducer.isAuthenticated,
        token: state.authenticationReducer.accessToken,
        fileStatus: state.paymentReducer.fileStatus
    }));

    useEffect(() => {
        let SockJS = require("sockjs-client");
        stompClient = Stomp.over(SockJS);

        // const onMessageReceived = (msg) => {
        //   // dispatch({type: "", payload: ""})
        //   console.log("=============msg", msg);
        // };

        const onError = (err) => {
            // console.log(err);
            // if(isAuthenticated) {
            // SockJS = new SockJS(`${webSocketBaseURL}?access_token=${token}`);
            // stompClient = Stomp.over(SockJS);
            // stompClient.connect({}, onConnected, onError);
            // }
        };

        if (isAuthenticated) {
            const onConnected = (data) => {
                // console.log("connected");
            };
            const connect = () => {
                SockJS = new SockJS(`${config.webSocketBaseURL}?access_token=${token}`);
                stompClient = Stomp.over(SockJS);
                stompClient.connect({}, onConnected, onError);
                stompClient.debug = null;
            };
            connect();
        }
    }, [isAuthenticated, token, dispatch, fileStatus]);
    return null;
};
export { stompClient };
export default SocketCLient;
